export type ChipFocusTarget = {type: 'chip'; id: string} | {type: 'cleared'};

/**
 * After the focused chip is removed, focus the chip that slides into its place.
 * If it was the last chip, focus the previous one. If none remain, leave the summary.
 */
export function focusTargetAfterRemoval(removedIndex: number, remainingIds: readonly string[]): ChipFocusTarget {
    if (remainingIds.length === 0) {
        return {type: 'cleared'};
    }

    const index = Math.min(Math.max(removedIndex, 0), remainingIds.length - 1);

    return {type: 'chip', id: remainingIds[index]};
}

function isOnScreen(element: HTMLElement | null): element is HTMLElement {
    return !!element && element.getClientRects().length > 0;
}

/** Filter toggle on a narrow screen, otherwise the sort control in the open panel. */
export function focusAfterActiveFiltersCleared(): void {
    if (typeof document === 'undefined') {
        return;
    }

    const toggle = document.getElementById('menu-toggle');
    if (isOnScreen(toggle)) {
        toggle.focus();
        return;
    }

    const sort = document.getElementById('sort-by');
    if (isOnScreen(sort)) {
        sort.focus();
    }
}
